import { useQuery } from '@tanstack/react-query';
import MarketPace from '@app/model/market_insight/MarketPace';
import { MarketInsightQueryKeys } from '@app/model/market_insight/service/MarketInsightQueryKeys';
import MarketInsightService from '@app/model/market_insight/service/MarketInsightService';

// The pace strip of Market Pulse: one call per page of the demand panel (the first and the last
// stay date of the page). `enabled` follows the pace setting of the hotel.
export function useMarketPaceQuery(companyHotelId: number, fromDate: string | undefined, toDate: string | undefined, enabled: boolean) {
	return useQuery({
		queryKey: MarketInsightQueryKeys.pace(companyHotelId, fromDate ?? '', toDate ?? ''),
		refetchOnWindowFocus: false,
		enabled: enabled && fromDate !== undefined && toDate !== undefined,
		queryFn: async (): Promise<MarketPace | null> => {
			if (fromDate === undefined || toDate === undefined) return null;
			return (await MarketInsightService.findMarketPace({ companyHotelId, fromDate, toDate })) ?? null;
		},
	});
}
